import { render, staticRenderFns } from "./RegistrationTimeSlotList.vue?vue&type=template&id=0fa7833e&scoped=true&"
import script from "./RegistrationTimeSlotList.vue?vue&type=script&lang=js&"
export * from "./RegistrationTimeSlotList.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationTimeSlotList.vue?vue&type=style&index=0&id=0fa7833e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7833e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VListItem,VListItemContent,VListItemSubtitle,VRow,VTooltip})
